const handleCards = () => {
  if (!window.matchMedia("(min-width: 768px)").matches) {
    return;
  }

  document.querySelectorAll(".element-cardstack").forEach((el) => {
    const cardItems = el.querySelectorAll(".card-item");
    const progressCount = el.querySelector(".card-progress-count");
    const progressBar = el.querySelector(".card-progress-bar");

    cardItems.forEach((card, index) => {
      const style = window.getComputedStyle(card);
      const stickyTop = parseInt(style.getPropertyValue("top"));
      const cardRect = card.getBoundingClientRect();
      const cardMedia = card.querySelector(".media-block");
      const cardMediaRect = cardMedia.getBoundingClientRect();
      const cardContent = card.querySelector(".card-content");
      const cardContentRect = cardContent.getBoundingClientRect();

      if (index > 0) {
        card.classList.toggle("is-active", cardRect.top <= stickyTop);
      }

      const diff = cardRect.top - stickyTop;

      if (cardContentRect.height >= cardMediaRect.height && diff < 0) {
        const heightDiff = cardContentRect.height - cardMediaRect.height;

        if (diff * -1 < heightDiff) {
          cardMedia.style.transform = `translate3d(0, ${diff * -1}px, 0)`;
        } else {
          cardMedia.style.transform = `translate3d(0, ${heightDiff}px, 0)`;
        }
      } else {
        cardMedia.style.transform = null;
      }
    });

    const totalCards = cardItems.length;
    let activeCardCount = el.querySelectorAll(".card-item.is-active").length;

    if (activeCardCount === 0) {
      activeCardCount = 1;
    }

    const cardCount = activeCardCount.toString().padStart(2, "0");
    progressBar.style.transform = `scaleX(${activeCardCount / totalCards})`;

    progressCount.textContent = cardCount;
  });
};

window.addEventListener("scroll", handleCards);

handleCards();
